// eslint-disable-next-line import/default
import FieldKit from 'field-kit';
import InputText from './input-text';

/**
 * This component renders a numbers only input with percentage formatting. It is a extension of
 * <Prism::InputText /> and supports all the same properties. It takes a number between 0 and 1
 * (inclusive) as its value and represents in the DOM as a percentage, e.g. value = .15 will
 * appear as 15% on the screen
 *
 * @example
 * ```
 * <Prism::InputPercent
 *   @value={{this.nameOfValueProperty}}
 *   @inputId="my-id"
 *   @inputClass="some-class some-other-class"
 *   @label="Percentage"
 *   @placeholder="Percent value of thing"
 *   @onChange={{action (mut nameOfValueProperty))}}
 * />
 * ```
 *
 */

function decimalPad(str) {
  const paddedStr = `00${str}`;
  return `${paddedStr.slice(0, -2)}.${paddedStr.slice(-2)}`;
}
class PercentFormatter extends FieldKit.NumberFormatter {
  isChangeValid(change) {
    super.isChangeValid(change);
    const isBackspace = change.proposed.text.length < change.current.text.length;
    let newValue;
    if (change.proposed.text === this.percentSymbol() || change.proposed.text === '') {
      change.proposed.text = '';
      return true;
    }
    try {
      newValue = this.parse(change.proposed.text, str => {
        throw new Error(str);
      });
    } catch {
      return false;
    }
    if (isBackspace) {
      if (change.deleted.text === this.percentSymbol()) {
        newValue = (newValue * 100).toString().slice(0, -1);
        if (newValue === '') {
          change.proposed.text = '';
          return true;
        } else {
          newValue = Number.parseFloat(decimalPad(newValue));
        }
      }
    }
    if (typeof newValue === 'number' && !Number.isNaN(newValue) && newValue >= 0 && newValue <= 1) {
      const newText = this.format(newValue);
      change.proposed.text = newText;
      if (change.proposed.selectedRange.start === newText.length) {
        change.proposed.selectedRange = {
          start: newText.length - 1,
          length: 0
        };
      }
      return true;
    } else {
      return false;
    }
  }
}
export default InputText.extend({
  maxlength: 4,
  // This should cause a numerical keyboard to appear on mobile
  inputType: 'tel',
  formatter: new PercentFormatter().setNumberStyle(FieldKit.NumberFormatter.Style.PERCENT).setLenient(true),
  actions: {
    _onChange(event) {
      const value = this.field.value();
      if (this.onChange) {
        this.onChange(value, event);
      }
    }
  }
});